import React, { useContext, useEffect, useState } from "react"
import IconCircle from "./icon-circle"
import {Link} from "gatsby"
import ChangeQuantity from "../hooks/changeQuantity"
import QuantityControl from "./quantity-control"
import AddToCartToast from "./add-to-cart-toast"
import IconCircleAccent from "./cart/icon-circle-accent"
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

const ToolSubscriptionCard = ({ sku, color, title, hex, listPrice, icon, desc, subIcon, tooltip, padding, loggedIn, permission, contactUs, loginWithRedirect = () => {} }) => {
    let [formattedTotal, setTotal] = useState('$0.00')
    let [showToast, setShowToast] = useState(false)
    let { addToCart } = ChangeQuantity()

    useEffect(() => { }, [formattedTotal])

    useEffect(() => {
        let cart = typeof window !== undefined && window.localStorage.getItem('cart');
        cart = JSON.parse(cart);
        if(!!cart && cart[sku]){
            setTotal(cart[sku].formattedTotal)
        }
    }, [sku])

    const setNewTotal = (newTotal) => {
        setTotal(newTotal)
    }

    const add = () => {
        addToCart(sku, title, setShowToast)
    }
    
    return(
        <div className='col-lg-3 col-sm-6 mb-4'>
            <div className='card h-100'>
                <div className='card-body d-flex flex-column'>
                    <p className={`text-${color} font-lg text-uppercase text-center mb-2`}>
                        {title}
                    </p>
                    <p className='text-muted font-md text-center'>
                        {listPrice}
                    </p>
                    <div className="position-relative mx-auto my-4">
                        {subIcon !== undefined ?
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip id={`tooltip-${tooltip}`}>{tooltip}</Tooltip>
                                }
                            >   
                                <div style={{ width: '0px', right: '0.5rem', top: '-0.5rem', position: 'absolute',}}>
                                    <IconCircleAccent
                                        content={
                                            <IconCircle 
                                                size={'2rem'} 
                                                color={'#f93b3b'}
                                                icon={subIcon}
                                                additionalClass={`mx-auto mb-0 mt-0 text-critical`}
                                                padding={padding}
                                            /> 
                                        }
                                    />
                                </div>
                            </OverlayTrigger>
                            
                        :
                            <></>
                        }
                        <IconCircle 
                            size={'5rem'} 
                            color={hex}
                            icon={icon}
                            additionalClass={`mx-0 mb-0 mt-0 text-${color}`}
                        /> 
                    </div>
                    {desc !== undefined ?
                        <p className="text-muted font-md text-center">{desc}</p>
                    :
                        <></>
                    }
                    {permission && !contactUs ? 
                        <div className='d-flex flex-column mb-0 mt-auto'>
                            <QuantityControl sku={sku} callback={setNewTotal}/>
                            <div className='d-flex text-muted mt-4'>
                                <div className='mx-auto'>Total</div>
                                <div className='mx-auto'>{formattedTotal}</div>
                            </div>
                            <button className='btn btn-yellow mx-auto mt-4' onClick={add}>Add to Cart</button>
                            <Link to={'/cart'} className='mx-auto mt-4'><button className='btn btn-primary'>Go to Cart</button></Link>
                        </div>
                        :
                        contactUs ? 
                        <div className='d-flex mb-0 mt-auto'>
                            <Link to={'/contact-us'} className="mx-auto"><button className='btn btn-yellow'>Contact Us</button></Link>
                        </div>
                        :
                        <div className='d-flex mb-0 mt-auto'>
                            <button className='btn btn-yellow mx-auto' onClick={() => loginWithRedirect()}>Sign in to Order Now</button>
                        </div>
                    }
                </div>
            </div>
            <AddToCartToast show={showToast} toggle={() => setShowToast(!showToast)}/>
        </div>
    )
    

}

export default ToolSubscriptionCard;